import classNames from "classnames";
import { ReactNode } from "react";

interface SellingCardProps {
  element?: ReactNode;
  title: string;
  paragraph1: string;
  paragraph2?: string;
  paragraph3?: string;
  className?: string;
}

const paragraphClassName = "text-white";

export const SellingCard = ({
  element,
  title,
  paragraph1,
  paragraph2,
  paragraph3,
  className,
}: SellingCardProps) => {
  return (
    <div
      className={classNames(
        "w-full flex flex-col gap-8 min-h-72 max-h-[24rem] rounded-xl border-2 border-sendolab-gray p-6 overflow-hidden",
        className
      )}
    >
      <div className="flex gap-4 items-start">
        <div className="flex-shrink-0">{element}</div>
        <p
          className="text-2xl text-business-green font-medium"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      </div>
      <div className="flex flex-col gap-6">
        <p
          className={paragraphClassName}
          dangerouslySetInnerHTML={{ __html: paragraph1 }}
        />
        {paragraph2 && (
          <p
            className={paragraphClassName}
            dangerouslySetInnerHTML={{ __html: paragraph2 }}
          />
        )}
        {paragraph3 && (
          <p
            className={paragraphClassName}
            dangerouslySetInnerHTML={{ __html: paragraph3 }}
          />
        )}
      </div>
    </div>
  );
};
